export default function debouncePromise(fn, delay) {
  let timer, p = Promise.resolve();
  return inner;

  function inner(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => p.then(() => {timer = setTimeout(call, delay, this, args)}), 0);
  }
  function call(innerThis, args) {
    p = Promise.resolve(fn.apply(innerThis, args));
  }
}



// WEBPACK FOOTER //
// ./src/lib/debouncePromise.js